// extracted by mini-css-extract-plugin
export default {"field":"field_field__f29Zz","label":"field_label__uap1z","horizontalLabel":"field_horizontalLabel__wSAAk","horizontalField":"field_horizontalField__l0n3m"};